@if (!(shown || invisibleButton)) {
    <print-button
        (notifyOpen)="notifyOpen($event)"
        [buttonText]="'Antrag ausdrucken'"></print-button>
}

<div id="printDialogue" [class.hide]="!shown" [class.show]="shown">

    <div print-header (notifyOpen)="notifyOpen($event)"></div>

    <div class="printContent alsBriefbogen show">

        <!-- DOCUMENT TITLE -->
        <h1 class="printTitle">Änderungsantrag</h1>


        <!-- CONTENT START -->

        <!-- Änderungsantrag / fürs Vertiffen -->
        <div class="gridContainer">

            <h2>Änderung der Basisdaten (RI-0040)</h2>

            <div class="gridContainer dataGrid">

                <div class="row">
                    <div class="cell grid-100">
                        <div class="dataGroup">
                            <div class="dataItem">
                                <span class="label">Partner-ID:</span>
                                <span class="value">{{ model.externePartnerId }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="cell grid-100">
                        <div class="dataGroup">
                            <div class="dataItem">
                                <span class="label">560er-Nummer:</span>
                                <span class="value">{{ ordnungsbegriff }}</span>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="row">
                    <div class="cell grid-50">
                        <div class="dataGroup">
                            <div class="dataItem">
                                <span class="label">Name des VN / des Partners<br/>(original Wert aus Panda):</span>
                                <div class="valueGroup">
                                    <span class="value">{{ model.vorname.oldValue }}</span>
                                    <span class="value">{{ model.name.oldValue }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cell grid-50">
                        @if (model.vorname.changed || model.name.changed) {
                            <div class="dataGroup">
                                <div class="dataItem">
                                    <span class="label">
                                        Name des VN / des Partners<br/>(durch Kunden geänderter Wert):
                                    </span>
                                    <div class="valueGroup">
                                        <span class="value">{{ model.vorname.recentValue }}</span>
                                        <span class="value">{{ model.name.recentValue }}</span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                <div class="row">
                    <div class="cell grid-50">
                        <div class="dataGroup">
                            <div class="dataItem">
                                <span class="label">
                                    Anschrift  des VN / des Partners inkl. PLZ/Ort<br/>(original Wert aus Panda):
                                </span>
                                <div class="valueGroup">
                                    <span class="value">{{ model.adresszeile1.oldValue }}</span>
                                    <span class="value">{{ model.adresszeile2.oldValue }}</span>
                                    <span class="value">{{ model.adresszeile3.oldValue }}</span>
                                    <span class="value">{{ model.adresszeile4.oldValue }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cell grid-50">
                        @if (model.adresszeile1.changed || model.adresszeile2.changed || model.adresszeile3.changed || model.adresszeile4.changed) {
                            <div class="dataGroup">
                                <div class="dataItem">
                                <span class="label">
                                    Anschrift  des VN / des Partners inkl. PLZ/Ort<br/>(durch Kunden geänderter Wert):
                                </span>
                                    <div class="valueGroup">
                                        <span class="value">{{ model.adresszeile1.recentValue }}</span>
                                        <span class="value">{{ model.adresszeile2.recentValue }}</span>
                                        <span class="value">{{ model.adresszeile3.recentValue }}</span>
                                        <span class="value">{{ model.adresszeile4.recentValue }}</span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                <div class="row">
                    <div class="cell grid-50">
                        <div class="dataGroup">
                            <div class="dataItem">
                                <span class="label">
                                    Telefonnummer<br/>(original Wert aus Panda):
                                </span>
                                <div class="valueGroup">
                                    <span class="value">{{ model.telefon.oldValue }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cell grid-50">
                        @if (model.telefon.changed) {
                            <div class="dataGroup">
                                <div class="dataItem">
                                    <span class="label">Telefonnummer<br/>(durch Kunden geänderter Wert):</span>
                                    <div class="valueGroup">
                                        <span class="value">{{ model.telefon.recentValue }}</span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                <div class="row">
                    <div class="cell grid-50">
                        <div class="dataGroup">
                            <div class="dataItem">
                                <span class="label">E-Mail-Adresse<br/>(original Wert aus Panda):</span>
                                <div class="valueGroup">
                                    <span class="value">{{ model.email.oldValue }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cell grid-50">
                        @if (model.email.changed) {
                            <div class="dataGroup">
                                <div class="dataItem">
                                  <span class="label">E-Mail-Adresse<br/>(durch Kunden geänderter Wert):</span>
                                      <div class="valueGroup">
                                          <span class="value">{{ model.email.recentValue }}</span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                <div class="row">
                    <div class="cell grid-100">
                        <div class="dataGroup">
                            <div class="dataItem">
                                <span class="label">Freies Textfeld für Anmerkungen:</span>
                                <div class="valueGroup">
                                    <span class="value">{{ model.texteingabe }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="cell grid-100">
                        Diese Änderung wurde am <strong>{{ getDate() }}</strong> von <strong>{{ kundenName }}</strong> beantragt.
                    </div>
                </div>

            </div>

        </div>
        <!-- CONTENT END -->

    </div>
    <!-- ENDE printContent -->

</div>
